import React, { useState, useEffect } from 'react';
import './GoldRateDropdown.css';
import axios from 'axios';
const GoldRateDropdown = () => {
  const [prices, setPrices] = useState({ gold: null, silver: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Replace with your API endpoint
    const fetchPrices = async () => {
      
        // Step 2: Fallback to local getAllRates API
        try {
          const localResponse = await axios.get(
            'https://vimaljewellery.com/api/v1/rates',
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          const rates = localResponse.data // Array of RateData objects

          if (rates && rates.length > 0) {
            // Sort by createdAt descending and take the latest
            const latestRate = rates.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )[0]
            setPrices({
              gold: latestRate.goldRate,
              silver: latestRate.silverRate,
            })
            setLoading(false)
          } else {
            setError('No rates available in local database')
            setLoading(false)
          }
        } catch (localErr) {
          console.error('Failed to fetch local rates:', localErr)
          // setError('Rs:106') // Default fallback value or error message
          setLoading(false)
          try {
            const response = await axios.get('https://jerwishtech.site/v1/api/account/todayrate');
            setPrices({
              gold: response.data.Rate, // Adjust based on your API response structure
              silver: response.data.SILVERRATE, // Adjust based on your API response structure
            });
            setLoading(false);
          } catch (err) {
            console.warn(
              'Primary API failed, falling back to local rates:',
              err.message
            )
        
        }
      }
    };

    fetchPrices();
  }, []); // Empty dependency array means this runs once when the component mounts

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  // Fetch rates with Axios


  return (
    <div className="dropdown-container">
      {/* <div className="rate-label">Today's Rate:</div> */}
      <div className="dropdown">
        <button className="dropdown-toggle" >
          <span>GOLD 1G: ₹{prices.gold}</span>
          {/* <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span> */}
        </button>


      </div>
    </div>
  );
};

export default GoldRateDropdown;